import React from 'react'

const StockView = () => {
  return (
    <div>StocksView</div>
  )
}

export default StockView